import { redirectRouter } from '@/hooks/router-redirect'
import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw, RouteLocationRaw } from 'vue-router'
const clientChildrenRoutes = [
  {
    path: 'client-list',
    name: 'clientList',
    component: () => import('@/views/client/client-list.vue'),
    meta: {
      title: '组织列表',
      iconfont: 'icon-user-settings-line',
      requiredPermission: 'CLIENT_LIST',
    }
  },
  {
    path: 'menu-list',
    name: 'menuList',
    component: () => import('@/views/client/menu-list.vue'),
    meta: {
      title: '菜单列表',
      iconfont: 'icon-file-line',
      requiredPermission: 'MENU_LIST',
    }
  },
  {
    path: 'permission-list',
    name: 'permissionList',
    component: () => import('@/views/client/permission-list.vue'),
    meta: {
      title: '权限管理',
      iconfont: 'icon-folder-keyhole-line',
      requiredPermission: 'PERMISSION_LIST',
    }
  },
  // 字典配置
  {
    path: 'dictionary-config-list',
    name: 'dictionaryConfigList',
    component: () => import('@/views/client/dictionary-config-list.vue'),
    meta: {
      title: '字典配置',
      iconfont: 'icon-book-2-line',
      requiredPermission: 'DICTIONARY_CONFIG_LIST',
    }
  },
  {
    path: 'dictionary-config-child',
    name: 'dictionaryConfigChild',
    component: () => import('@/views/client/dictionary-config-child.vue'),
    meta: {
      hideInMenu: true,
      parentNameForBreadcrumb: 'dictionaryConfigList',
      // actionRouterName: 'dictionaryConfigList'
    }
  },
  {
    path: 'faq-list',
    name: 'faqList',
    component: () => import('@/views/client/faq-list.vue'),
    meta: {
      title: '帮助中心',
      iconfont: 'icon-help_outline_black_24dp',
      requiredPermission: 'FAQ_LIST',
    }
  },
]
export const clientRoutes: CustomRouteRecordRaw = {
  path: 'client',
  name: 'client',
  component: EmptyLayout,
  redirect: (): RouteLocationRaw => redirectRouter(clientChildrenRoutes),
  meta: {
    title: '组织管理',
    iconfont: 'icon-community-line',
    desc: '以组织为维度内容',
    requiredPermission: 'CLIENT',
    noQuick: true

  },
  children: clientChildrenRoutes
}
